import { useQuery, useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';

export interface UserDashboardPreference {
  id: string;
  userId: string;
  dashboardName: string;
  widgets: string | null;
}

const BASE_PATH = '/api/core/dashboard-preferences';

export const dashboardPreferenceKeys = {
  all: ['dashboardPreference'] as const,
  byDashboard: (name: string) => [...dashboardPreferenceKeys.all, name] as const,
};

export function useUserDashboardPreference(dashboardName: string) {
  return useQuery({
    queryKey: dashboardPreferenceKeys.byDashboard(dashboardName),
    queryFn: async () => {
      const { data } = await apiClient.get<UserDashboardPreference | null>(
        `${BASE_PATH}/${dashboardName}`,
      );
      return data;
    },
  });
}

export function useSaveDashboardPreference(dashboardName: string) {
  return useMutation({
    mutationFn: async (widgets: string) => {
      const { data } = await apiClient.put<UserDashboardPreference>(
        `${BASE_PATH}/${dashboardName}`,
        { widgets },
      );
      return data;
    },
  });
}

export function useResetDashboardPreference(dashboardName: string) {
  return useMutation({
    mutationFn: async () => {
      await apiClient.delete(`${BASE_PATH}/${dashboardName}`);
    },
  });
}
